import { CrewMerchantUi } from 'corso-types';
import { createContext, PropsWithChildren, useContext, useEffect } from 'react';
import { identifyUser } from '~/utils/observability';

export type CorsoUser = CrewMerchantUi.UserWithStoreUserRoles;

const UserContext = createContext<CorsoUser | null>(null);

export function useUser() {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error(
      'UserContext unavailable. Did you forget to use a UserProvider?',
    );
  }

  return context;
}

export function useUserOrgs() {
  const user = useUser();

  // ! we want to only filter / show organizations that aren't the corso store organization (user page, etc)
  return user.organizationUserRoles.filter((o) => !o.isCorsoOrg);
}

/** Given a `user`, provides it for all the descendants to use. */
export function UserProvider({
  user,
  children,
}: PropsWithChildren<{
  user: CorsoUser;
}>) {
  useEffect(() => {
    identifyUser({ email: user.email });
  }, [user]);

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}
